import { SkillAccessibility } from "@/shared/domain/skills";

/**
 * How each accessibility tier is presented. Split from `VisibilityChip` — the
 * one component that renders the first two — because a module exporting both
 * components and constants breaks React Fast Refresh.
 */

/** Display label for each tier, used by the visibility chip. */
export const ACCESSIBILITY_LABEL: Record<SkillAccessibility, string> = {
  private: "Private",
  org: "Org",
  "org-editable": "Org-editable",
};

/**
 * MUI Chip color per tier. `private` is the neutral grey; `org` is the primary
 * blue; `org-editable` gets its own green so the "anyone can edit this" tier
 * reads as distinct at a glance.
 */
export const ACCESSIBILITY_CHIP_COLOR: Record<
  SkillAccessibility,
  "default" | "primary" | "success"
> = {
  private: "default",
  org: "primary",
  "org-editable": "success",
};

/**
 * Author-facing menu copy for each tier, shown in the visibility dropdown.
 * Tiers are ordered private → org → org-editable; the dropdown lets the
 * author jump straight to any tier (no cycle), so downgrading `org-editable`
 * to plain `org` never has to pass through `private` — which would prune
 * every non-author subscription.
 */
export const ACCESSIBILITY_MENU_COPY: Record<SkillAccessibility, string> = {
  private: "Private (only you)",
  org: "Org (everyone in your org can use it)",
  "org-editable": "Org-editable (everyone in your org can use and edit it)",
};

export const ACCESSIBILITY_ORDER: SkillAccessibility[] = [
  "private",
  "org",
  "org-editable",
];
